export default __webpack_public_path__ + "static/media/noRace.f6125d67.png";